var _style, _desc, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuantum(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 29",
    style: {
      enableBackground: "new 0 0 25 29"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#5596E6;stroke-width:0.8611;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#5596E6;stroke-width:0.8611;stroke-linecap:round;stroke-miterlimit:10;}\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.4,8.1c0.7,0,1.3-0.6,1.3-1.3S5.2,5.5,4.4,5.5c-0.7,0-1.3,0.6-1.3,1.3S3.7,8.1,4.4,8.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.6,24.3c0.7,0,1.3-0.6,1.3-1.3s-0.6-1.3-1.3-1.3c-0.7,0-1.3,0.6-1.3,1.3S19.9,24.3,20.6,24.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.3,7.8l14.5,14.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.2,18.7c-1.2,0.2-2.4,0.2-3.6,0.2c-6.5,0-11.8-1.8-11.8-4c0-1.4,2.1-2.6,5.4-3.3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.8,11.2c1.2-0.1,2.4-0.2,3.8-0.2c6.5,0,11.8,1.8,11.8,4c0,1.4-2.2,2.7-5.6,3.3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.8,24.2c-2,1.6-4.6,2.5-7.3,2.5C6,26.8,0.7,21.4,0.7,14.9c0-2.7,1-5.3,2.5-7.3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.2,5.6C7.2,4,9.7,3,12.5,3c6.5,0,11.9,5.3,11.9,11.9c0,2.8-1,5.4-2.6,7.4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuantum);
export default __webpack_public_path__ + "../static/product-explorer/assets/quantum.948a560bab228d5f9a4b65bc4acd0289.svg";
export { ForwardRef as ReactComponent };